import { useSnackbar } from "@gemini/ui";
import { useI18n } from "@/contexts/i18n";
import { useTravelTimeContext } from "@/location/contexts";
export const useBrowserPosition = () => {
    const { setLoadingState } = useTravelTimeContext();
    const { add } = useSnackbar();
    const { t } = useI18n();
    const getUserPosition = async () => {
        setLoadingState("fetching_position");
        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject);
            });
            setLoadingState("success");
            return {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
            };
        }
        catch (error) {
            setLoadingState("failure");
            add({
                variant: "error",
                description: t("location.map.modal.travel_times.position.snackbar.error"),
            });
        }
    };
    return {
        getUserPosition,
    };
};
